module.exports = __webpack_public_path__ + "img/c2m_coop.330a8295.png";